<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Teams from "../../../services/Teams";
import Events from "@/components/tabs/tabFixtureEvents.vue";
import Lineups from "@/components/tabs/tabFixtureLineups.vue";
import Stats from "@/components/tabs/tabFixtureStats.vue";
import Preview from "@/components/tabs/tabFixturePreview.vue";
import TextFormModal from "@/components/modals/fixtures/modalEditPreviewText.vue";
export default {
  page: {
    title: "Current Fixtures",
    meta: [
      {
        name: "fixtures_currents",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stats,
    Lineups,
    Events,
    Preview,
    TextFormModal,
  },

  data() {
    return {
      id: this.$route.params.id,
      openedTab: "preview",
      baseUrl: process.env.VUE_APP_API_BASEURL,
      fixture: null,
      previewLoading: false,
      title: "",
      items: [
        {
          text: "Admin",
        },
        {
          text: "",
          active: true,
        },
      ],
      modalIsOpened: false,
    };
  },
  methods: {
    /**
     * GET /football/matches/{id}/extended returns { match, events, stats, lineups } (no top-level success/preview).
     * Legacy GET /team/match/{id}/extended returned { success, match, preview, events, stats, lineups }.
     * Normalize so tabs and header keep using fixture.data.* shape.
     */
    normalizeFootballExtendedResponse(response) {
      if (!response || !response.data) return response;
      const d = response.data;
      if (d.success === true && d.match) {
        return response;
      }
      if (!d.match || d.events === undefined) {
        return response;
      }
      const m = typeof d.match === "object" ? { ...d.match } : d.match;
      const preview = m.preview || {
        home_team_form: [],
        away_team_form: [],
        preview_text: null,
      };
      let scoreFormatted = (m.score && m.score.formatted) || "";
      if (
        !scoreFormatted &&
        m.score_home != null &&
        m.score_away != null
      ) {
        scoreFormatted = `${m.score_home} - ${m.score_away}`;
      }
      m.score = { ...(m.score || {}), formatted: scoreFormatted };
      if (!m.progress) {
        m.progress = {
          is_FT: m.match_status === "Played" ? "Y" : "N",
        };
      }
      if (!m.competition) {
        m.competition = {
          competition_name: m.competition_name || "",
          season: m.tournament_name || m.season || "",
        };
      }
      m.venue = m.venue || m.venue_name || "";
      m.referee_name = m.referee_name || m.referee_main_name || "";

      response.data = {
        success: true,
        match: m,
        preview,
        events: this.normalizeFixtureEvents(d.events),
        stats: this.normalizeFixtureStats(d.stats),
        lineups: this.normalizeFixtureLineups(d.lineups),
      };
      return response;
    },
    normalizeFixtureStats(stats) {
      if (!Array.isArray(stats)) return stats || [];
      return stats.map((s) => {
        if (s && s.stat_desc != null) return s;
        const hp = Number(s.home_points);
        const ap = Number(s.away_points);
        const total = (Number.isFinite(hp) ? hp : 0) + (Number.isFinite(ap) ? ap : 0);
        return {
          stat_code: s.stat_code != null ? s.stat_code : String(s.stat_id != null ? s.stat_id : ""),
          stat_desc: s.stat_desc || s.stat_name || "",
          total_points: s.total_points != null ? s.total_points : total,
          home_points: s.home_points,
          away_points: s.away_points,
        };
      });
    },
    normalizeFixtureLineups(lineups) {
      if (!lineups || typeof lineups !== "object") return lineups;
      const mapRow = (row) => ({
        ...row,
        shirt_number:
          row.shirt_number != null ? row.shirt_number : row.player_shirt_number,
      });
      return {
        ...lineups,
        home_team_starters: (lineups.home_team_starters || []).map(mapRow),
        away_team_starters: (lineups.away_team_starters || []).map(mapRow),
        home_team_subs: (lineups.home_team_subs || []).map(mapRow),
        away_team_subs: (lineups.away_team_subs || []).map(mapRow),
      };
    },
    shortPlayerLabel(name) {
      if (!name || typeof name !== "string") return "";
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (parts.length === 0) return "";
      if (parts.length === 1) return parts[0];
      return `${parts[0].charAt(0)}. ${parts.slice(1).join(" ")}`;
    },
    normalizeFixtureEvents(events) {
      if (!Array.isArray(events)) return [];
      return events
        .map((ev) => {
          if (!ev) return null;
          if (ev.team === "home" || ev.team === "away") return ev;
          const team = ev.place === "home" ? "home" : "away";
          let score = ev.score;
          if (
            (score === "" || score == null) &&
            ev.home_goals != null &&
            ev.away_goals != null
          ) {
            score = `${ev.home_goals}-${ev.away_goals}`;
          }
          return {
            id: ev.event_id || ev.id,
            team,
            event_minute: ev.event_minute || "",
            name: ev.name || ev.event_type_name || ev.comment || "",
            player_short:
              ev.player_short || this.shortPlayerLabel(ev.player_name),
            second_player_short:
              ev.second_player_short ||
              this.shortPlayerLabel(ev.related_player_name),
            score: score || "",
          };
        })
        .filter(Boolean);
    },
    async getFixture() {
      this.previewLoading = true;

      await Teams.fixtureDetails(this.id)
        .then((response) => {
          this.fixture = this.normalizeFootballExtendedResponse(response);
          if (this.fixture.data && this.fixture.data.match) {
            this.title = `${this.fixture.data.match.home_team_name} vs ${this.fixture.data.match.away_team_name}`;
            this.items[1].text = `${this.fixture.data.match.home_team_short} vs ${this.fixture.data.match.away_team_short}`;
          }
        })
        .catch((error) => {
          this.error = error.response.data.error
            ? error.response.data.error
            : "";
        })
        .finally(() => {
          this.previewLoading = false;
        });
    },
    changeTab(tabName) {
      this.openedTab = tabName;
    },

    changeModalView() {
      if (this.modalIsOpened === false) {
        this.modalIsOpened = true;
      } else {
        this.modalIsOpened = false;
      }
    },
  },
  mounted() {
    this.getFixture();
  },

};
</script>
<template>
  <div>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body" v-if="fixture && fixture.data && fixture.data.match">
                <div class="container">
                  <div class="row">
                    <div class="d-flex justify-content-between">
                      <div>
                        {{ fixture.data.match.competition.competition_name }}
                        {{ fixture.data.match.competition.season }}
                      </div>
                      <div>Round {{ fixture.data.match.round }}</div>
                    </div>
                  </div>
                  <div
                    v-if="fixture.data.match.score.formatted != ''"
                    class="row justify-content-center"
                  >
                    {{ fixture.data.match.date_formatted }}
                  </div>
                  <div class="row  align-items-center g-2">
                    <div class="col">
                      <div class="row justify-content-center">
                        <img
                          class="w-50"
                          :src="fixture.data.match.home_team_logo"
                          alt=""
                        />
                      </div>
                      <div class="row fs-3 fw-bolder justify-content-center">
                        {{ fixture.data.match.home_team_name }}
                      </div>
                    </div>
                    <div class="col">
                      <div v-if="fixture.data.match.score.formatted != ''">
                        <div class="row fs-1  justify-content-center">
                          {{ fixture.data.match.score.formatted }}
                        </div>
                      </div>
                      <div
                        class="row fs-5  justify-content-center align-items-center"
                        v-else
                      >
                        {{ fixture.data.match.date_formatted }}
                      </div>
                      <div
                        class="row"
                        v-if="fixture.data.match.progress.is_FT === 'N'"
                      ></div>
                    </div>
                    <div class="col">
                      <div class="row justify-content-center">
                        <img
                          class="w-50"
                          :src="fixture.data.match.away_team_logo"
                          alt=""
                        />
                      </div>
                      <div class="row fs-3 fw-bolder justify-content-center">
                        {{ fixture.data.match.away_team_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hr m-5">
                  <div v-if="openedTab === 'events'">
                    <Events :fixture="fixture" @changeTab="changeTab" />
                  </div>
                  <div v-if="openedTab === 'stats'">
                    <Stats :stats="fixture.data.stats" @changeTab="changeTab" />
                  </div>
                  <div v-if="openedTab === 'lineups'">
                    <Lineups
                      :lineup="fixture.data.lineups"
                      @changeTab="changeTab"
                    />
                  </div>
                  <div v-if="openedTab === 'preview'">
                    <Preview
                      :fixture="fixture"
                      :previewLoading="previewLoading"
                      @changeTab="changeTab"
                      @openModal="changeModalView"
                      @onRefresh="getFixture()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>



    <TextFormModal
      :fixture="fixture"
      v-if="modalIsOpened === true"
      @closeModal="changeModalView"
    />
  </div>
</template>